<mat-sidenav-container fullscreen>
    <mat-sidenav #right
                 mode="over"
                 position="end"
                 disableClose="true"
                 [opened]="false">
        <ng-container #rightTemplate></ng-container>
    </mat-sidenav>

    <mat-sidenav-content>
        <div>
            <ng-content></ng-content>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
